import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { isGlobalSidenavEnabled } from "iron/routes/global-sidenav/utils";
import { Visibility, VisibilityEvents } from "../base/stackable";
import { SvgIconEl } from "../svg-icon";
import { Direction, OtherTogglePanelSource } from "./types";
import { COLLAPSE_LABEL, SHOW_LABEL } from "./constants";
export function template() {
  const {
    print
  } = this.getContext("i18n");
  const panelName = this.attr("panel-name") || "";
  const actionTooltipTranslatable = this.isCollapsed() ? SHOW_LABEL[panelName] : COLLAPSE_LABEL[panelName];
  let actionTooltipText = print(actionTooltipTranslatable);
  if (this.collapseShortcutLabel) {
    actionTooltipText = "".concat(actionTooltipText, " ").concat(this.collapseShortcutLabel);
  }
  const showContentFooter = this._footerContent || this.attr("show-collapse-button") || this.showAlignmentToggle();
  return /* @__PURE__ */ jsx("div", { sel: ".wrapper", class: {
    "align-bottom": this.helpers.getAlignment() === Direction.Bottom,
    "align-right": this.helpers.getAlignment() === Direction.Right,
    "align-left": this.helpers.getAlignment() === Direction.Left,
    "has-open-dropdown": this.state.hasOpenDropdown,
    "is-collapsed": this.isCollapsed(),
    "is-resizing": this.state.isResizing,
    "global-sidenav-enabled": isGlobalSidenavEnabled(this.currentProject),
    ["theme-".concat(this.attr("theme"))]: true
  }, attrs: {
    elref: "wrapper"
  }, on: {
    [VisibilityEvents[Visibility.Open]]: () => this.update({
      hasOpenDropdown: true
    }),
    // displays scrollbars when a child dropdown is closed
    [VisibilityEvents[Visibility.Closed]]: (ev) => this.update({
      hasOpenDropdown: ev.detail.stackSize !== 1
    })
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, !this.isCollapsed() && this._headerContent && /* @__PURE__ */ jsx("div", { sel: ".content-header", attrs: {
    elref: "contentHeader"
  } }, this._headerContent), /* @__PURE__ */ jsx("div", { sel: ".content-scroller" }, /* @__PURE__ */ jsx("div", { sel: ".content-wrapper" }, /* @__PURE__ */ jsx("slot", { "data-sentry-element": "slot", "data-sentry-source-file": "template.tsx" }))), showContentFooter && /* @__PURE__ */ jsx("div", { sel: ".footer-section", class: {
    "show-alignment-toggle": this.showAlignmentToggle(),
    "show-divider": Boolean(this._footerContent),
    ["theme-".concat(this.attr("theme"))]: true
  } }, this.showAlignmentToggle() && /* @__PURE__ */ jsx(ButtonEl, { sel: ".alignment-toggle", attrs: {
    elref: "alignmentToggle",
    theme: ButtonTheme.Tertiary,
    "not-focusable": true,
    tooltip: {
      text: print(this.helpers.getAlignmentToggleTooltipText()),
      placement: this.helpers.getSideButtonTooltipDirection()
    }
  }, on: {
    click: () => {
      this.update({
        isHoveringAlignmentToggle: false
      });
      this.toggleAlignment();
    },
    mouseover: () => this.update({
      isHoveringAlignmentToggle: true
    }),
    mouseleave: () => this.update({
      isHoveringAlignmentToggle: false
    })
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: this.helpers.getAlignmentToggleIcon()
  } })), this._footerContent && /* @__PURE__ */ jsx("div", { sel: ".footer-content", attrs: {
    elref: "footerContent"
  } }, this._footerContent), this.attr("show-collapse-button") && /* @__PURE__ */ jsx(ButtonEl, { sel: ".collapse-button", attrs: {
    elref: "collapseButton",
    theme: ButtonTheme.Tertiary,
    "not-focusable": true,
    tooltip: {
      text: actionTooltipText,
      placement: this.helpers.getSideButtonTooltipDirection()
    }
  }, on: {
    click: () => this.toggleCollapsed({
      source: OtherTogglePanelSource.Button
    })
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: this.helpers.getCollapseButtonIconDirection()
  } }))), !this.isCollapsed() && !this.attr("fixed-size") && /* @__PURE__ */ jsx("div", { sel: ".resize-handle", on: {
    mousedown: (ev) => this.startResizing(ev)
  }, class: {
    "resize-right": this.helpers.getResizeDirection() === Direction.Right,
    "resize-left": this.helpers.getResizeDirection() === Direction.Left,
    "resize-top": this.helpers.getResizeDirection() === Direction.Top
  }, attrs: {
    elref: "resizeHandle"
  } }));
}
